module.exports = __webpack_public_path__ + "f58ef1e962abaf911e75127b5fe06bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/emerald.png
// module id = 766
// module chunks = 0